import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import withScrollableView from "../../components/scrollable/withScrollableView";

// The SubwaySyncScroller provides an outer wrapper around the SubwayNodeCanvasView
// and the SubwayThreadColumnView so they scroll together vertically.
// We do not have any synced scrolling between different Subway Views.

const SubwaySyncScroller = props => {
  return <Fragment>{props.children}</Fragment>;
};

SubwaySyncScroller.propTypes = {
  // Any special instructions when placing the data?
  children: PropTypes.element,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,

  // Also accessed by ScrollableView
  requestViewBoundsForZoom: PropTypes.func.isRequired
};

const scrollableViewOptions = {
  scrollHorizontally: false,
  scrollVertically: true,
  showVerticalScrollbar: true
};

export default withScrollableView(SubwaySyncScroller, scrollableViewOptions);
